import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxJsonSchema } from 'rxdb';

import { defaultDoc } from '../share/defaultDoc';

export interface ComponentRemovalCategories {
  readonly name: string;
  readonly pkComponentRemovalCategory: number;
  readonly sort: number;
  readonly isActive: boolean;
  readonly dateModified?: string;
  readonly dateCreated?: string;
}

export const componentRemovalCategoriesSchema: RxJsonSchema<ComponentRemovalCategories> = {
  type: 'object',
  version: 0,
  description: 'describes component removal',
  primaryKey: 'name',
  properties: {
    pkComponentRemovalCategory: { type: 'number' },
    name: { type: 'string', maxLength: 36 },
    sort: { type: 'number' },
    isActive: { type: 'boolean' },
    dateModified: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
  },
};

export type ComponentRemovalCategoriesCollection = RxCollection<ComponentRemovalCategories> | null;

export const componentRemovalCategoriesPullQueryBuilder = (
  document: ComponentRemovalCategories,
) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mainComponentRemovalCategories($lastRequested: DateTime!) {
      mainComponentRemovalCategories(lastRequested: $lastRequested) {
        name
        sort
        isActive
        dateModified
        dateCreated
        pkComponentRemovalCategory
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified || doc?.dateCreated },
  };
};

export default {};
